function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Image } from "expo-image";
import { useState } from "react";
import { Modal, PixelRatio, Platform } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { getMuxThumbnail, isMuxUrl } from "@oui/lib/src/muxUrl";
import { useTheme } from "../../styles";
import { Button } from "../Button";
import { Card, CardStack } from "../CardStack";
import { HeaderButtons, HeaderItem } from "../HeaderButtons";
import { MediaPlayer } from "../MediaPlayer";
import { Label, Text } from "../Text";
import { View } from "../View";
/**
 * Shows the user an explanatory video for the product. Clicking the CTA opens
 * the video for playback in a modal.
 *
 *
 *
 * Has two variants:
 *
 * **Block**
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̉̀̀̃̀̀̀̆̄̀̀̃̈̀̀̆̅̀̀̃̄̀̀̃̄̀̀̆́̀̀̂̍̀̀̆̂̀̀̃̂̀̀̃̈̀̀̆̂̀̀̂̍̀̀̃̄̀̀̃̅̀̀̆̅̀̀̆̂̀̀̂̍̀̀̆́̀̀̆̃̀̀̃̅̀̀̆̄̀̀̂̍̀̀̃̃̀̀̃̂̀̀̃̉̀̀̃̄̀̀̆̆̀̀̆̃̀̀̃̈̀̀̃̄̀̀̆́̀̀̃̇̀̀̆̂̀̀̃̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃̂̀̀̃̀̀̀̃̆̀̀̂̍̀̀̃̂̀̀̃́̀̀̃̃̀̀̃̅̀̀̃̄̀̀̃̉̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃́̀̀̃́̀̀̃́̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃̇̀̀̃̆̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * **Inline**
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̂̀̀̆̄̀̀̆̃̀̀̃̅̀̀̆̅̀̀̃̀̀̀̆́̀̀̆̄̀̀̂̍̀̀̆̄̀̀̃̆̀̀̆̄̀̀̆́̀̀̂̍̀̀̃̄̀̀̃̇̀̀̃̂̀̀̆́̀̀̂̍̀̀̆́̀̀̆́̀̀̃̇̀̀̆̂̀̀̂̍̀̀̃̅̀̀̃̈̀̀̃̆̀̀̃̆̀̀̃̂̀̀̆̄̀̀̃̆̀̀̃̉̀̀̃̉̀̀̃̄̀̀̃̀̀̀̆̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃̂̀̀̃̀̀̀̃̆̀̀̂̍̀̀̃̂̀̀̃́̀̀̃̃̀̀̃̆̀̀̃̃̀̀̃̇̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̆̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃́̀̀̃̂̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-33}
 */ export var ExplanationVideo = function(param) {
    var muxUrl = param.muxUrl, variant = param.variant;
    var theme = useTheme().theme;
    var insets = useSafeAreaInsets();
    var _useState = _sliced_to_array(useState(false), 2), showVideo = _useState[0], setShowVideo = _useState[1];
    if (!isMuxUrl(muxUrl)) throw new Error('Invalid muxUrl for ExplanationVideo');
    var ui = /*#__PURE__*/ _jsx(Button, {
        text: "Watch a clinician explain more",
        icon: "play",
        onPress: function() {
            return setShowVideo(true);
        },
        size: "small",
        variant: "text"
    });
    if (variant === 'block') {
        ui = /*#__PURE__*/ _jsxs(View, {
            style: {
                borderRadius: 10,
                paddingHorizontal: 15,
                paddingVertical: 7,
                backgroundColor: theme.color.gray800,
                gap: 15
            },
            row: true,
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    source: getMuxThumbnail(muxUrl, {
                        format: 'jpg',
                        height: 46,
                        width: 46,
                        getPixelSizeForLayoutSize: PixelRatio.getPixelSizeForLayoutSize
                    }),
                    style: {
                        width: 46,
                        height: 46,
                        borderRadius: 5
                    }
                }),
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            text: "Want to learn more?",
                            size: 15,
                            color: theme.color.gray300
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            text: "Watch a clinician explain",
                            icon: "play",
                            onPress: function() {
                                return setShowVideo(true);
                            },
                            size: "small",
                            variant: "text"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            ui,
            /*#__PURE__*/ _jsxs(Modal, {
                visible: showVideo,
                onRequestClose: function() {
                    return setShowVideo(false);
                },
                children: [
                    /*#__PURE__*/ _jsx(SystemBars, {
                        style: "light"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            paddingTop: insets.top,
                            backgroundColor: theme.color.gray100,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                row: true,
                                style: {
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(HeaderButtons, {
                                        left: true,
                                        children: /*#__PURE__*/ _jsx(HeaderItem, {
                                            "aria-label": "Close",
                                            iconName: "close",
                                            title: "",
                                            color: "white",
                                            onPress: function() {
                                                return setShowVideo(false);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Label, {
                                        text: "Dr. Bryan",
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            opacity: 0
                                        },
                                        "aria-hidden": true,
                                        children: /*#__PURE__*/ _jsx(HeaderButtons, {
                                            children: /*#__PURE__*/ _jsx(HeaderItem, {
                                                "aria-label": "Close",
                                                iconName: "close",
                                                title: "",
                                                color: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    paddingTop: 48,
                                    paddingBottom: insets.bottom,
                                    paddingHorizontal: 20
                                },
                                children: /*#__PURE__*/ _jsx(CardStack, {
                                    hideNextButtonIndexes: true,
                                    // hide pagination UI
                                    hasCompleteCard: true,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        children: /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                margin: -25,
                                                marginTop: -26,
                                                borderRadius: 15,
                                                overflow: 'hidden'
                                            },
                                            children: showVideo ? /*#__PURE__*/ _jsx(MediaPlayer, {
                                                _enableSkipToEnd: global.e2e,
                                                // detox has trouble synchronizing on android when video autoplays... so a workaround is to
                                                // disable autoplay in this case
                                                autoPlay: !(global.e2e && Platform.OS === 'android'),
                                                uri: muxUrl,
                                                onClose: undefined,
                                                aspectRatio: 9 / 16,
                                                resizeMode: "cover"
                                            }) : null
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
